import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing long term price development for crop commodities, crude oil, gold, DAX and S&P Index in absolute values or based on an index',
    'Source: NYSE, USDA (Commodity Prices) , EIA (Crude Oil), Onvista (Gold), BASF investor relations (DAX and S&P 500)'
  ];
  return description;
}